<template>
    <div class="formgrid grid ">
        <div class="col-8">
            <div class="grid">
                <div class="col-6">
                    <h2>Şablondan Diyet Ata</h2>
                </div>
                <div class="col-6"></div>
                <div class="col-6">
                    <label for="Diyetler" class="font-bold block">Diyetler</label>
                    <Select id="Diyetler" v-model="pDiyetTanim" :options="DiyetListesi" optionLabel="DiyetTanimAd"
                        optionValue="DiyetTanim_rowid" placeholder="Seçiniz..." checkmark filter
                        :highlightOnSelect="true" :invalid="this.Valid.pDiyetTanim" class="text-base text-color w-full"
                        @change="DiyetTanimChange" />
                </div>
                <div class="col-6">
                    <Button label="Atama Yap" severity="warn" size="large" icon="pi pi-sign-in" iconPos="left"
                        style="width: 100%;" @click="SablonDiyetAta()" class="mt-4" :disabled="IslemYapiliyor"
                        v-if="!IslemYapiliyor" />
                </div>

                <div class="col-12">
                    <IslemYapiliyor v-if="IslemYapiliyor" />
                </div>
            </div>
        </div>
        <ConfirmDialog></ConfirmDialog>
    </div>
</template>
<script>
import GlobalServis from "../../../../../../services/GlobalServis";
export default {
    props: {
        pMusteri: Number
    },
    data() {
        return {
            IslemYapiliyor: false,
            pDiyetTanim: 0,
            DiyetListesi: [],

            Valid: {
                pDiyetTanim: false,
            }
        }
    },
    methods: {
        SablonDiyetAta() {
            this.IslemYapiliyor = true;
            this.$confirm.require({
                message: 'İlgili kullanıcıya seçilen şablon diyeti atanacaktır. ',
                header: 'Emin Misin ?',
                icon: 'pi pi-question-circle',
                rejectClass: 'p-button-secondary p-button-outlined',
                rejectLabel: 'Hayır',
                acceptLabel: 'Evet',
                accept: () => {

                    let data = {
                        pDiyetTanim: this.pDiyetTanim,
                        pMusteri: this.pMusteri,
                    };
                    GlobalServis.GlobalServis("POST", "SetSablonDiyetKopyala", data).then((res) => {
                        if (res.status == 200) {
                            this.$toast.add({
                                severity: "success",
                                summary: "Başarılı",
                                detail: "Diyet şablonu danışana atanmıştır.",
                                life: 3000,
                            });
                            window.location.reload();
                        } else if (res.response.status === 999) {
                            this.$toast.add({
                                severity: "warn",
                                summary: "Uyarı",
                                detail: res.response.data,
                                life: 3000,
                            });
                        } else {
                            this.$toast.add({
                                severity: "error",
                                summary: "Hata",
                                detail: "Hata oldu",
                                life: 3000,
                            });
                        }
                    }).then(() => {
                        this.IslemYapiliyor = false;
                    });
                },
                reject: () => {
                    this.$toast.add({ severity: 'error', summary: 'Red', detail: 'İptal Edildi', life: 3000 });
                }
            });
        },
        _DiyetListesi() {
            GlobalServis.GlobalServis("GET", "GetDiyetTanimTablosu", "").then((res) => {
                if (res.status == 200) {
                    this.DiyetListesi = res.data;
                } else if (res.response.status === 999) {
                    this.$toast.add({
                        severity: "warn",
                        summary: "Uyarı",
                        detail: res.response.data,
                        life: 3000,
                    });
                } else {
                    this.$toast.add({
                        severity: "error",
                        summary: "Hata",
                        detail: "Hata oldu",
                        life: 3000,
                    });
                }
            }).then(() => {
            });
        },

    },
    created() {
        this._DiyetListesi();
    },
    components: {
    }
};
</script>